import {
  oDataTypeConfig,
  transformAssetId,
} from './request-transformer-util';

export const transformDeleteAssetRequest = ({ folderAssetType, assetId }) => ({
  Asset: {
    '@odata.type': oDataTypeConfig[folderAssetType],
    Id: transformAssetId(assetId),
  },
});
